import Axios  from "axios"

export const getOrigens = (origens) => async (dispatch) => {
    dispatch({
        type: 'ORIGEN_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/origen/getall/', {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )      
        if(status===200){            
            dispatch({
                type: 'ORIGENS_GET_SUCCESS',
                payload: data.origens
            }) 
        }

    } catch (error) {
        dispatch({
            type: 'ORIGEN_ERROR'           
        })         
    }
}

export const getOrigenDetail = (origen) => async (dispatch) => {
    dispatch({
        type: 'ORIGEN_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/origen/get/'+ origen, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )            
        if(status===200){            
            dispatch({
                type: 'ORIGEN_GET_DETAIL_SUCCESS',
                payload: data.origen
            })             
        }

    } catch (error) {
        dispatch({
            type: 'ORIGEN_ERROR'           
        })         
    }
}

export const addOrigen = (name, type, distances) => async (dispatch) => {
    dispatch({
        type: 'ORIGEN_LOADING'
    })
    try {
        const {
            data,
            status
        } = await Axios.post(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/origen/register', {
                name: name,
                type: type,
                distances: distances
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            let newOrigen = {
                _id: data.id,
                name: name,
                type: type,
                distances: distances
            }
            dispatch({
                type: 'ORIGEN_ADD_SUCCESS',
                payload: newOrigen
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORIGEN_FAIL'
        })
    }
}

export const editOrigen = (name, type, distances, idOrigen) => async (dispatch) => {
    dispatch({
        type: 'ORIGEN_LOADING'
    })
    try {
        await Axios.put(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/origen/edit/' + idOrigen, {
                name: name,
                type: type,
                distances: distances
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        dispatch({
            type: 'ORIGEN_EDIT_SUCCESS',
            payload: {
                name: name,
                type: type,
                distances: distances,
                _id: idOrigen
            }
        })
    } catch (error) {
        dispatch({
            type: 'ORIGEN_ERROR'
        })
    }
}

export const removeOrigen = (idOrigen) => async (dispatch) => {
    try {
        const {
            data,
            status
        } = await Axios.delete(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/origen/remove/' + idOrigen, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'ORIGEN_DELETE_SUCCESS',
                payload: {
                    idOrigen: idOrigen,
                    message: data.message,
                    count: data.count
                }
            })
        }else{
            dispatch({
                type: 'ORIGEN_DELETE_NOT_SUCCESS',
                payload: {
                    message: data.message,
                    count: data.count
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORIGEN_ERROR'
        })
    }
}